import React, { useState } from "react";
import { Link } from "react-router-dom";
import { popinfo } from "component/Fancybox/Fancybox";
import api from "api";
import "./index.scss";

const GetInitiativeStatusLabel = (initiative, labelKey) => {
    switch(labelKey)
    {
        case 'recruitment':
            return initiative.InitiativeType == 'event' ? 'Registration' : 'Enrollment';
        case 'work-in-progress':
            return initiative.InitiativeType == 'event' ? 'On Going' : 'Active';
        case 'rating':
            return initiative.InitiativeType == 'event' ? 'Feedback' : 'Review';
        case 'completed':
            return initiative.InitiativeType == 'event' ? 'Event Closed' : 'Completed';
    }
}

const GetInitiativeStatusName = (initiative) => {
    switch(initiative.CurrentStatus)
    {
        case 'recruitment':
            return GetInitiativeStatusLabel(initiative, 'recruitment');
        case 'work-in-progress':
            return GetInitiativeStatusLabel(initiative, 'work-in-progress');
        case 'rating':
            return GetInitiativeStatusLabel(initiative, 'rating');
        case 'completed':
            return GetInitiativeStatusLabel(initiative, 'completed')
    }
}

const GetInitiativeStatusDesc = (InitiativeType, CurrentStatus) => {
    switch(CurrentStatus)
    {
        case 'recruitment':
            return InitiativeType != 'event'
            ? 'In this phase, the creator invites other users to join the initiative. During this time, the discussion room is open to all logged-in Crowdbees users to foster collaboration and alignment on the initiative\'s goals.'
            : 'In this phase, participants register for the event. The discussion room is accessible to all logged-in Crowdbees users, allowing for initial engagement and information sharing.' 
            ;
        case 'work-in-progress':
            return InitiativeType != 'event'
            ? 'In this phase, all members actively work on the tasks outlined in the initiative. The discussion room remains open, serving as a space for ongoing collaboration, progress updates, and troubleshooting.'
            : 'In this phase, the event is actively taking place. Participants are engaged in the scheduled activities, and any real-time coordination or adjustments are managed through the discussion room, which remains open for communication and support during the event.' 
            ;
        case 'rating':
            return InitiativeType != 'event'
            ? 'In this phase, the initiative has been completed. A space for mutual ratings will be opened, allowing all collaborators to provide ratings for each other.'
            : 'In this phase, the event has concluded. A space for feedback will be opened, allowing all participants to provide their feedback on the event\'s success and share their evaluations.' 
            ;
        case 'completed':
            return InitiativeType != 'event'
            ? 'In this phase, the initiative is formally closed. All tasks should be completed, and the results are summarized. The the discussion room is archived, making it read-only for future reference.'
            : 'In this phase, the event is officially concluded. The discussion room is archived, ensuring that all information is preserved for future reference.' 
            ;
    }
}

const SetInitiativeStatus = (InitiativeID, Status, UserToken) => {
    return new Promise((resolve, reject) => {
        let SavingLoader = popinfo('loader', 'Updating Status',  'Please Wait' );
    
        api('/Initiative/Status', 'post', {
            InitiativeID : InitiativeID
            ,CurrentStatus : Status
        } , 'Bearer ' + UserToken)
            .then(function(response){
    
                SavingLoader.close();
    
                resolve(response.initiative);
    
            })
            .catch((error) => {
                popinfo('error', 'Updating Status', error, {}, SavingLoader);

                reject(error);


            });
    });
}

export default function InitiativeCard(props){
    const [initiative] = useState(props.initiative);

    return(
        <div className="initiative-card">
            <div className={`card-${initiative.InitiativeType} -has-image initiative-card-wrapper shadow relative`}>
                <span className={`side-ribbon bg-${initiative.InitiativeType}`}>{initiative.InitiativeType}</span>
                <span className="image-box cover initiative-image">
                {
                    initiative.PosterImage 
                    ? <img src={initiative.PosterImage} alt={initiative.title} />
                    : <img src={`${process.env.PUBLIC_URL}/assets/image/crowdbees-default-${Math.floor(Math.random() * 3) + 1}.jpeg`}/>
                }
                </span> 
                <div className="information-block">
                    {/* <span className="initiative-category">{initiative.InitiativeType}</span> */}
                    <h3 className="initiative-title leading-relaxed">{initiative.Title}</h3>
                    <span className="initiator meta-text">By {initiative.UserDisplayName}</span>
                    <div className="initiative-metas">
                        <div>
                            <span className="meta-text">Status</span>
                            <span className="meta-value">{GetInitiativeStatusName(initiative)}</span>
                        </div>
                        {
                            typeof initiative.TotalJoined !== 'undefined' && 
                            <div className="text-right">
                                <span className="meta-text">Talents Joined</span>
                                <span className="meta-value">
                                    {initiative.TotalJoined}
                                    {initiative.Capacity > 0 && ` of ${initiative.Capacity}`}
                                </span>
                            </div>
                        }
                    </div>
                </div>
                <Link to={`/initiative/${initiative.Slug}`} className="absolute inset"/>
            </div>
        </div>
    )
}

export {GetInitiativeStatusLabel, GetInitiativeStatusName, GetInitiativeStatusDesc, SetInitiativeStatus};